import axios from 'axios';

import { API_BASE_URL } from '../../constants';

export const getConfluenceApiError = (error) => {
    const data = error?.response?.data || {};
    let message = '';

    if (typeof data.message === 'string') {
        message = data.message;
    } else if (typeof data.message?.details?.error === 'string') {
        message = data.message.details.error;
    } else if (typeof data.error === 'string' && data.error !== 'feature_inactive') {
        message = data.error;
    }

    const savedButInvalid = typeof data.error === 'string'
        && data.error.includes('saved but validation failed');

    return {
        status: error?.response?.status,
        message,
        code: data.error === 'feature_inactive' || data.code === 'feature_inactive'
            ? 'feature_inactive'
            : '',
        savedButInvalid,
    };
};

export default class ConfluenceSettingsService {
    static instance;

    resource = `${API_BASE_URL}/confluence_setting`;

    static getInstance() {
        if (!ConfluenceSettingsService.instance) {
            ConfluenceSettingsService.instance = new ConfluenceSettingsService();
        }

        return ConfluenceSettingsService.instance;
    }

    getHeaders() {
        return {
            Authorization: `Bearer ${localStorage.getItem(
                'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
            )}`,
        };
    }

    async fetchSettings() {
        const response = await axios.get(this.resource, {
            headers: this.getHeaders(),
        });

        return response.data?.data;
    }

    async saveSettings(settings) {
        const response = await axios.post(`${this.resource}/edit`, settings, {
            headers: {
                ...this.getHeaders(),
                'Content-Type': 'application/json',
            },
        });

        if (response.data?.ok === false) {
            const error = new Error(response.data.error || 'Request failed');
            error.response = {
                data: response.data,
                status: response.status,
            };
            throw error;
        }

        return response.data;
    }

    async toggleActivation() {
        const response = await axios.post(`${this.resource}/toggle_active`, null, {
            headers: {
                ...this.getHeaders(),
                'Content-Type': 'application/json',
            },
        });

        if (response.data?.ok === false) {
            const error = new Error(response.data.error || 'Request failed');
            error.response = {
                data: response.data,
                status: response.status,
            };
            throw error;
        }

        return response.data;
    }

    async testConnection(payload) {
        const response = await axios.post(`${this.resource}/validate`, payload, {
            headers: this.getHeaders(),
        });

        if (response.data?.ok === false) {
            const error = new Error(response.data.error || 'Request failed');
            error.response = {
                data: response.data,
                status: response.status,
            };
            throw error;
        }

        return response.data;
    }
}
